module.exports = __webpack_public_path__ + "static/media/circleColor_googleplus.1d257d9a.svg";